var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46875 9.33341L10.9688 11.8334L17.6354 5.16675",
    stroke: "#FEFEFE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6341 10.1667V15.1667C17.6341 15.6087 17.4585 16.0326 17.146 16.3452C16.8334 16.6577 16.4095 16.8333 15.9674 16.8333H5.96745C5.52542 16.8333 5.1015 16.6577 4.78894 16.3452C4.47638 16.0326 4.30078 15.6087 4.30078 15.1667V5.16667C4.30078 4.72464 4.47638 4.30072 4.78894 3.98816C5.1015 3.67559 5.52542 3.5 5.96745 3.5H13.4674",
    stroke: "#FEFEFE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkIcon);
export default __webpack_public_path__ + "static/media/checkMarkIcon.b4223bd47d28f642dc21ebf6e1885fd6.svg";
export { ForwardRef as ReactComponent };